import { Tabs } from 'antd';

import type { TWorkJourneyManagementTab } from '@src/models/interfaces/workJourneyManagement.interface';

import styles from './styles.module.less';

interface WorkJourneyManagementTabItem {
  key: TWorkJourneyManagementTab;
  label: string;
  count?: number;
}

interface WorkJourneyManagementTabsProps {
  activeTab: TWorkJourneyManagementTab;
  tabItems: WorkJourneyManagementTabItem[];
  onTabChange: (tab: string) => void;
}

export const WorkJourneyManagementTabs = ({
  activeTab,
  tabItems,
  onTabChange,
}: WorkJourneyManagementTabsProps) => {
  const items = tabItems.map(tab => ({
    key: tab.key,
    label:
      tab.count != null && tab.count > 0 ? (
        <span className={styles.tabLabel}>
          {tab.label}
          <span className={styles.tabCount}>{tab.count}</span>
        </span>
      ) : (
        tab.label
      ),
  }));

  return (
    <div className={styles.tabsBar}>
      <Tabs activeKey={activeTab} items={items} onChange={onTabChange} className={styles.tabs} />
    </div>
  );
};
